import { render, staticRenderFns } from "./basicData.vue?vue&type=template&id=47c7a3ed&"
import script from "./basicData.vue?vue&type=script&lang=js&"
export * from "./basicData.vue?vue&type=script&lang=js&"
import style0 from "./basicData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47c7a3ed')) {
      api.createRecord('47c7a3ed', component.options)
    } else {
      api.reload('47c7a3ed', component.options)
    }
    module.hot.accept("./basicData.vue?vue&type=template&id=47c7a3ed&", function () {
      api.rerender('47c7a3ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/basicData.vue"
export default component.exports